import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Divider } from '../../Divider'
import { TabScrollList } from '../../Tab'
import { useNewsboardPostProfileContext } from '../Newsboard.hooks'
import { NewsboardPostProfileTabComments } from '../NewsboardPostProfileTabComments'

import { NEWSBOARD_POST_PROFILE_TAB_COMMENTS } from './NewsboardPostProfileTabs.constants'
import { getIsNewsboardPostProfileTabComments } from './NewsboardPostProfileTabs.utils'

import * as styles from './NewsboardPostProfileTabs.module.css'

function NewsboardPostProfileTabs() {
  const { t } = useTranslation()

  const { isInitiated } = useNewsboardPostProfileContext()

  const [activeTab, setActiveTab] = useState(
    NEWSBOARD_POST_PROFILE_TAB_COMMENTS
  )

  const preparedTabs = [
    {
      id: NEWSBOARD_POST_PROFILE_TAB_COMMENTS,
      text: t('Newsboard.CommentsActionTooltipKey'),
    },
  ]

  return (
    <>
      <Divider className={styles.divider} />
      <TabScrollList
        activeTab={activeTab}
        preparedTabs={preparedTabs}
        onSetActiveTab={setActiveTab}
      />
      {isInitiated && getIsNewsboardPostProfileTabComments(activeTab) ? (
        <NewsboardPostProfileTabComments />
      ) : null}
    </>
  )
}

export default NewsboardPostProfileTabs
